import React, { } from 'react'
import { Cascader, Form, InputNumber, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { DashboardSettingType, QueryExpression } from '../../../constants/DashboardConf'
import Filter from './Filter'

const { COUNT, AVG, SUM } = QueryExpression
const { PIECHART } = DashboardSettingType
function ChartSetting (props) {
  const { defPlaceholder, defConfig, schema, chartType, sortOptions, usePiiSchema, piiSchema, crossData, crossDataSchema } = props
  const { t: ln_t } = useTranslation()
  const formVal = Form.useWatch() || {}

  const aggregateOptions = [{ value: SUM, label: ln_t('dashboard.sum') }, { value: AVG, label: ln_t('dashboard.avg') }, { value: COUNT, label: ln_t('dashboard.count') }]

  const usedSchema = crossData ? crossDataSchema : usePiiSchema ? piiSchema : schema

  const componentProps = { showSearch: true, options: usedSchema }
  const SelectComponent = (props) => crossData ? <Cascader {...componentProps} {...props} expandTrigger='hover' /> : <Select {...componentProps} {...props} optionFilterProp='children' />
  return (
    <>
      {chartType === PIECHART
        ? <Form.Item {...defConfig('groupBy', 'select')}>
            {SelectComponent({ placeholder: defPlaceholder('groupBy', 'select') })}
          </Form.Item>
        : <>
            <Form.Item {...defConfig('xAxis', 'select')}>
              {SelectComponent({ placeholder: defPlaceholder('xAxis', 'select') })}
            </Form.Item>
            <Form.Item {...defConfig('yAxis', 'select')}>
              {SelectComponent({ placeholder: defPlaceholder('yAxis', 'select') })}
            </Form.Item>
          </>
      }
      <Form.Item {...defConfig('aggregate', 'select')}>
        <Select showSearch disabled={usePiiSchema} placeholder={defPlaceholder('aggregate', 'select')} options={aggregateOptions} optionFilterProp="children" />
      </Form.Item>
      {chartType === PIECHART && (formVal.aggregate === SUM || formVal.aggregate === AVG)
        ? <Form.Item {...defConfig('aggregateColumn', 'select')}>
            {SelectComponent({ placeholder: defPlaceholder('aggregateColumn', 'select') })}
          </Form.Item>
        : ''}
      <Form.Item {...defConfig('order', 'select')}>
        <Select showSearch placeholder={defPlaceholder('order', 'select')} options={sortOptions} optionFilterProp="children" />
      </Form.Item>
      <Form.Item {...defConfig('limit', 'input', false)}>
        <InputNumber placeholder={defPlaceholder('limit', 'input')} precision={0} min={0} style={{ width: '100%' }} />
      </Form.Item>
      <Filter {...props} filterOpt={usedSchema} />
    </>
  )
}

export default ChartSetting
